<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section relative">
        <div class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]" />
        <UiContainer>
            <header class="mb-20 global-text">
                <h2>{{ blok?.title }}</h2>
            </header>
            <div>
                <div class="grid grid-cols-12 gap-6 max-[641px]:grid-cols-1 max-[641px]:gap-x-0 max-[641px]:gap-y-12">
                    <div
                        v-for="item in blok?.partners"
                        :key="item._uid"
                        class="col-span-3 max-[641px]:col-span-12"
                    >
                        <TeamItem
                            :image="item.logo"
                            :name="item.name"
                            :link="item.url"
                        />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
